import Card from "./card";
import { formatCategories } from "../../helpers";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { mobileScreen } from "utils/common";
const ARROW_ICON_SIZE = 50;
const Carousel = (props) => {
  const { loading } = props;
  const { t: translate } = useTranslation("categories");

  const handleNext = () => {
    if (document) {
      const carousel = document.querySelector(".carousel");
      if (carousel == null) {
        return;
      }
      const carouselItem = carousel.querySelector(".carouselItem");
      if (carouselItem == null) {
        return;
      }
      const carouselItemWidth = carouselItem.clientWidth;
      const clientWidth = carousel?.parentElement?.clientWidth;
      if (!clientWidth) {
        return;
      }
      if (carousel.scrollLeft + clientWidth < carousel.scrollWidth) {
        carousel.scrollBy({
          left: carouselItemWidth,
          top: 0,
          behavior: "smooth",
        });
      } else {
        carousel.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };
  const handlePrev = () => {
    if (document) {
      const carousel = document.querySelector(".carousel");
      if (!carousel) {
        return;
      }
      const carouselItem = carousel.querySelector(".carouselItem");
      if (!carouselItem) {
        return;
      }
      const carouselItemWidth = carouselItem.clientWidth;
      if (carousel.scrollLeft != 0) {
        carousel.scrollBy({
          left: -carouselItemWidth,
          top: 0,
          behavior: "smooth",
        });
      } else {
        carousel.scrollTo({
          left: carousel.scrollWidth,
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };

  const categories = formatCategories(props.data);
  const isServer = typeof window === "undefined";

  const isMobile = !isServer ? window?.innerWidth < mobileScreen : false;

  return (
    <>
      {/* Keeping the dir ltr to keep the carousel functionality working  */}
      <div className="flex w-[95%] items-center" dir="ltr">
        <div className="px-4">
          <button className="hidden md:flex " onClick={handlePrev}>
            <Image
              alt={translate("previousCategory")}
              src="/images/previousArrow.svg"
              width={ARROW_ICON_SIZE}
              height={ARROW_ICON_SIZE}
            />
          </button>
        </div>
        {/* max-w-min */}
        <div
          className={`flex  snap-x snap-mandatory overflow-x-auto my-4 w-full customScrollBar customCarouselScroll carousel xl:mx-auto mx-auto mt-0`}
          // Note: Tried using `scroll-px-[calc(50%-8rem)]` with Tailwind for scroll-padding,
          // but it didn’t work

          style={
            isMobile
              ? {
                  scrollPaddingInline: "calc(50% - 8rem)",
                  gap: "1rem",
                }
              : { gap: "6.7%" }
          }
        >
          {
            isMobile && <div className="shrink-0 w-[calc(50%-8rem)]" /> // div added to center last and first items in mobile view
          }
          {!loading
            ? categories?.map((item: any, index: number) =>
                isMobile ? (
                  <div
                    key={`__index__carousel__card__${index}`}
                    className="snap-center snap-always"
                  >
                    <Card
                      title={item?.name}
                      id={item?.id}
                      category={item?.slug}
                      image={item?.image}
                    />
                  </div>
                ) : (
                  <Card
                    key={`__index__carousel__card__${index}`}
                    title={item?.name}
                    id={item?.id}
                    category={item?.slug}
                    image={item?.image}
                  />
                ),
              )
            : Array.from(Array(7).keys()).map((item: any, index) =>
                isMobile ? (
                  <div
                    key={`__index__carousel__card__${index}`}
                    className="snap-center snap-always"
                  >
                    <Skeleton containerClassName="w-64" className="h-80" />
                  </div>
                ) : (
                  <Skeleton
                    key={`__index__carousel__card__${index}`}
                    containerClassName="w-64"
                    className="h-80"
                  />
                ),
              )}
          {
            isMobile && <div className="shrink-0 w-[calc(50%-8rem)]" /> // div added to center last and first items in mobile view
          }
        </div>
        <div className="px-4">
          <button className="hidden md:flex " onClick={handleNext}>
            <Image
              alt={translate("nextCategory")}
              src="/images/nextArrow.svg"
              width={ARROW_ICON_SIZE}
              height={ARROW_ICON_SIZE}
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default Carousel;
